import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

export function Checkmark(props: Props) {
  return (
    <SvgIcon {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 1.5C9.92329 1.5 7.89322 2.11581 6.1665 3.26957C4.43979 4.42332 3.09397 6.0632 2.29925 7.98182C1.50453 9.90045 1.2966 12.0116 1.70174 14.0484C2.10689 16.0852 3.10692 17.9562 4.57537 19.4246C6.04382 20.8931 7.91474 21.8931 9.95154 22.2982C11.9883 22.7034 14.0995 22.4955 16.0182 21.7007C17.9368 20.906 19.5767 19.5602 20.7304 17.8335C21.8842 16.1068 22.5 14.0767 22.5 12C22.5 9.21523 21.3937 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5ZM10.5 16.1931L6.74999 12.4431L7.94294 11.25L10.5 13.8069L16.0575 8.25L17.2543 9.43943L10.5 16.1931Z" fill="currentColor" />
      </svg>
    </SvgIcon>
  );
}
